import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import { SEOMetaTags } from './components/SEOMetaTags';
import { HreflangTags } from './components/HreflangTags';
import { StructuredData } from './components/StructuredData';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <>
      <HreflangTags />
      <StructuredData />
      <SEOMetaTags />
      <App />
    </>
  </React.StrictMode>
);
